/** Shared client/server copy when archiving a multi-unit plan is blocked. */
export const ARCHIVE_MULTI_UNIT_PLAN_MESSAGE =
  "Archiving isn't available for multi-unit plans. Delete the plan instead.";
